import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {

    DISABLE_2FA: {
        url: "2fa/disable",
        method: "post",
    },

    UPDATE_USER: (reporterId) => ({
        url: `admins/users/${reporterId}`,
        method: "patch",
    }),

    UPDATE_ADMIN: (reporterId) => ({
        url: `admins/${reporterId}`,
        method: "patch",
    }),

    GET_USERS: (
        pageSizeCount,
        pageNumber,
        searchValue,
        sorting,
        user,
        selectedCommunityId
    ) => ({
        url: `admins/users?pageSize=${pageSizeCount}&page=${pageNumber}&search=${searchValue}&key=${sorting.key}&order=${sorting.order}&searchUser=${user}&iCommunityId=${selectedCommunityId}`,
        method: "get",
    }),

    POST_IMPERSONATE_USER: {
        url: "admins?action=impersonate",
        method: "post",
    },

    POST_CREATE_FAVORITE: {
        url: "create-favorite-user",
        method: "post",
    },

    POST_REMOVE_FAVORITE: {
        url: "remove-favorite-user",
        method: "delete",
    },
};

export const useDisable2FA = () =>
    useApiFetcherSWR(API_ENDPOINT.DISABLE_2FA);

export const useUpdateUser = (reporterId) =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_USER(reporterId));

export const useUpdateAdmin = (reporterId) =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_ADMIN(reporterId));

export const useUsers = (
    pageSizeCount,
    pageNumber,
    searchValue,
    sorting,
    user,
    selectedCommunityId
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_USERS(
            pageSizeCount,
            pageNumber,
            searchValue,
            sorting,
            user,
            selectedCommunityId
        )
    );

export const useImpersonateUser = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_IMPERSONATE_USER);

export const useCreateFavorite = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_CREATE_FAVORITE);

export const useRemoveFavorite = () =>
    useApiFetcherSWR(API_ENDPOINT.POST_REMOVE_FAVORITE);